

















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { ICustomStylingClass } from '../types/custom.t';

@Component
export default class CustomTextArea extends Vue {

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: false })
  required!: boolean;

  @Prop({ default: false })
  readOnly!: boolean;

  @Prop()
  placeholder?: string;

  @Prop()
  maxlength?: number;

  @Prop()
  cols?: number;

  @Prop()
  rows?: number;

  @Prop()
  id?: string;

  @Emit('handle-input')
  handleInput(e: any): void {
    return e.target.value
  }

}
